<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-col cols="12" sm="12">
      <v-card class="box">
        <v-col cols="12" sm="12">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong>
                Grading Scheme
              </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-row align="center" justify="center">
            <v-col sm="3" md="3" v-for="link in link_data" :key="link.link">
              <v-card :elevation="5" class="card" fill-height style="margin: 8px; height: 90%;"
                :class="[currentPage.includes(link.link)?activeClass:'inactive']">
                <router-link :to="{ name: link.link}" class="link">
                  <v-list-item class="link-item">
                    <v-list-item-icon>
                      <v-icon class="linkname">{{ link.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="linkname">{{ link.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </v-card>
            </v-col>

          </v-row>
        </v-col>
      </v-card>
    </v-col>
    <router-view />
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    // extraBreadcrumbItems: [
      

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    link_data: [
      {
        link: "define-grading-scheme",
        icon: "mdi mdi-clipboard-plus",
        name: "Define Grading Scheme"
      },
      {
        link: "offer-grading-scheme",
        icon: "mdi-offer",
        name: "Offer Grading Scheme"
      },
      {
        link: "apply-grading-scheme",
        icon: "mdi-content-save",
        name: "Apply Grading Scheme"
      }
    ],
    activeClass:'active',
  }),
  computed:{
      currentPage(){
          return this.$route.path;
      }
  },
  mounted(){
    this.$router.push({ name: 'define-grading-scheme'})  
  },
};
</script>
<style scoped>
    .link {
        text-decoration: none;
    }
    .linkname{
      color: 0F2027;
    }
   
    .card {
       border-radius: 50px !important;
    }
    .card:hover {
        font-weight: bold !important;
        text-align: center;
        box-shadow: 20px 20px 20px grey !important;
        -webkit-transition:  box-shadow  0.3s ease-in !important;
    }
     .active {
        /* background: orange; */
        background: #bdc3c7; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); /* Chrome 10-25, Safari 5.1-6 */
        background: var(--v-brand-base); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        /* background-color: transparent; */
        box-shadow: 20px 20px 20px gray;
        color: white !important;
        font-weight: bold !important;
     }
     .active .linkname{
        color: white !important;
     }
     .inactive {
        /* background: #ffd699; */
        background-color: transparent;
        color: #0F2027;
        border: 1px solid #0F2027 !important;
    }
    .box {
        background-color: white !important;
        margin: 8px !important;
        padding: 8px;
        border: 2px solid #0F2027 !important;
    }
    .toolbar {
        background: #0F2027;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white;
    }
</style>